import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, Typography, IconButton, Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from 'react-redux';
import { ClientEnglishFallback } from '../constant/ClientEnglishFallback';

const SaveDraftModal = ({ open, onClose, onDiscard, onSaveDraft }) => {
    const { selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
    const accentColor = selectedClientData?.AccentColor || '#4F6EF7';

    const LANGUAGE = ClientEnglishFallback.ClientInspections(multiLanguageData?.ClientInspections || {});
    const {
        TEXT_DRAFT_OR_DISCARD,
        TEXT_DO_YOU_WANT_TO_SAVE_YOUR_CHANGES,
        TEXT_MODAL_DISCARD,
        TEXT_MODAL_SAVE_AS_DRAFT,
    } = LANGUAGE;

    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    borderRadius: '20px',
                    px: 1,
                    pb: 1,
                    minWidth: { xs: '85vw', sm: 360 },
                    boxShadow: '0 24px 60px rgba(0,0,0,0.14)',
                },
            }}
        >
            {/* Close */}
            <IconButton
                onClick={onClose}
                size="small"
                sx={{
                    position: 'absolute',
                    right: 12,
                    top: 12,
                    bgcolor: '#F5F6FA',
                    color: '#6B7280',
                    borderRadius: '10px',
                    '&:hover': { bgcolor: '#ECEEF2' },
                }}
            >
                <CloseIcon fontSize="small" />
            </IconButton>

            {/* Icon */}
            <Box sx={{ display: 'flex', justifyContent: 'center', pt: 3.5, pb: 0.5 }}>
                <Box
                    sx={{
                        width: 56,
                        height: 56,
                        borderRadius: '16px',
                        background: `linear-gradient(135deg, ${accentColor}22, ${accentColor}44)`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: `0 4px 16px ${accentColor}33`,
                    }}
                >
                    {/* Floppy disk / save icon via SVG */}
                    <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                        <path
                            d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z"
                            stroke={accentColor}
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <polyline
                            points="17 21 17 13 7 13 7 21"
                            stroke={accentColor}
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <polyline
                            points="7 3 7 8 15 8"
                            stroke={accentColor}
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </Box>
            </Box>

            <DialogTitle
                sx={{
                    textAlign: 'center',
                    fontWeight: 700,
                    fontSize: '1rem',
                    color: '#1A1D23',
                    letterSpacing: '-0.01em',
                    pt: 1.5,
                    pb: 0.5,
                }}
            >
                {TEXT_DRAFT_OR_DISCARD}
            </DialogTitle>

            <DialogContent sx={{ pb: 0 }}>
                <Typography
                    textAlign="center"
                    sx={{ color: '#6B7280', fontSize: '0.875rem', lineHeight: 1.6 }}
                >
                    {TEXT_DO_YOU_WANT_TO_SAVE_YOUR_CHANGES}
                </Typography>
            </DialogContent>

            <DialogActions
                sx={{
                    justifyContent: 'center',
                    gap: 1.5,
                    pt: 2.5,
                    pb: 1,
                    px: 2,
                    flexDirection: { xs: 'column', sm: 'row' },
                }}
            >
                <Button
                    variant="outlined"
                    onClick={onDiscard}
                    fullWidth
                    sx={{
                        borderRadius: '12px',
                        textTransform: 'none',
                        fontWeight: 600,
                        fontSize: '0.875rem',
                        py: 1.2,
                        color: '#374151',
                        borderColor: '#E5E7EB',
                        '&:hover': {
                            borderColor: '#D1D5DB',
                            bgcolor: '#F9FAFB',
                        },
                    }}
                >
                    {TEXT_MODAL_DISCARD}
                </Button>
                <Button
                    variant="contained"
                    onClick={onSaveDraft}
                    fullWidth
                    sx={{
                        bgcolor: accentColor,
                        borderRadius: '12px',
                        textTransform: 'none',
                        fontWeight: 700,
                        fontSize: '0.875rem',
                        py: 1.2,
                        boxShadow: `0 4px 14px ${accentColor}44`,
                        '&:hover': {
                            bgcolor: accentColor,
                            opacity: 0.9,
                            boxShadow: `0 6px 18px ${accentColor}55`,
                        },
                    }}
                >
                    {TEXT_MODAL_SAVE_AS_DRAFT}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SaveDraftModal;